import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { getCart } from '../../services/storeApi';

interface BootstrapLoaderProps {
    onLoaded?: () => void;
}

export function BootstrapLoader({ onLoaded }: BootstrapLoaderProps) {
    const [showText, setShowText] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const textTimer = setTimeout(() => setShowText(true), 500);
        const errorTimer = setTimeout(() => setError('Something went wrong'), 10_000);

        getCart()
            .then(() => {
                clearTimeout(errorTimer);
                onLoaded?.();
            })
            .catch(() => setError('Something went wrong'));

        return () => {
            clearTimeout(textTimer);
            clearTimeout(errorTimer);
        };
    }, [onLoaded]);

    if (error) {
        return (
            <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white px-4 text-center">
                <p className="text-[20px] font-semibold text-[#1a1a1a]">Something went wrong</p>
                <p className="text-[16px] text-[#6b7280]">
                    We couldn&apos;t load the checkout. Please refresh the page or contact the store if this keeps happening.
                </p>
                <button
                    className="rounded bg-[#1a1a1a] px-4 py-2 text-white hover:bg-black"
                    onClick={() => window.location.reload()}
                >
                    Refresh page
                </button>
            </div>
        );
    }

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-white">
            <Loader2 className="h-6 w-6 animate-spin text-[#1a1a1a]" />
            {showText && (
                <p className="text-[14px] font-semibold text-[#6b7280]">Loading your cart...</p>
            )}
        </div>
    );
}
